<template>
    <div class="MessageContent">
        <v-spacer v-if="!isUser"></v-spacer>
        <div class="message-text-container" style="background: #fff; padding: 6px">
            <table>
                <tr>
                    <td><v-icon small>mdi-account</v-icon></td>
                    <td v-html="formatEmailList(content.to)"></td>
                </tr>
                <tr>
                    <td><v-icon small>mdi-text-subject</v-icon></td>
                    <td>{{content.subject}}</td>
                </tr>
                <tr>
                    <td><v-icon small>mdi-format-text</v-icon></td>
                    <td>{{content.content}}</td>
                </tr>
                <tr>
                    <td><v-icon small>mdi-paperclip</v-icon></td>
                    <td>{{content.attachments}}</td>
                </tr>
                <tr>
                    <td>
                        <v-icon small v-if="content.include_conversation">mdi-check</v-icon>
                        <v-icon small v-else>mdi-close</v-icon>
                    </td>
                    <td>
                        include_conversation
                    </td>
                </tr>
            </table>
        </div>
    </div>
</template>

<script>
import MessageContent from "components/message-box/content/MessageContent";

export default {
    name: "MessageContentEmail",
    extends: MessageContent,
    methods: {
        formatEmailList(str) {
            return str.split(';').join('<br>')
        }
    }
}
</script>
